import { render, staticRenderFns } from "./MotionTypes.vue?vue&type=template&id=8208c05c"
import script from "./MotionTypes.vue?vue&type=script&lang=js"
export * from "./MotionTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports